import React, { useEffect } from "react";
import { Table } from "antd";
import { AreaChartOutlined } from "@ant-design/icons";
import languages from "../../constants/languages";
import { getNotificationList } from "../../services/server";

const ListNotifications = (props) => {
  const [data, setData] = React.useState([]);

  useEffect(() => {
    getNotificationList().then((res) => {
      setData(res.data);
    });
  }, []);

  const onClickCell = (record) => {
    props.onClickServer && props.onClickServer(record.server_id);
  };

  const formatDate = (dt) => {
    var date = new Date(dt);
    var dateStr =
      date.getFullYear() +
      "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + date.getDate()).slice(-2) +
      " " +
      ("00" + date.getHours()).slice(-2) +
      ":" +
      ("00" + date.getMinutes()).slice(-2) +
      ":" +
      ("00" + date.getSeconds()).slice(-2);
    return dateStr;
  };

  function errors(record) {
    let error = "";
    if (!record.tracking_id) {
      return error;
    }
    if (record && !record.tracking_id.content) {
      error = record.tracking_id.response_time
        ? "確認する文字列"
        : "正常とするレスポンスタイム";
    }
    if (record && !record.tracking_id.web_https) {
      error += error ? ",HTTPS" : "";
    }
    if (record && !record.tracking_id.web_ping) {
      error += error ? ",PING" : "";
    }
    if (record && !record.tracking_id.smtp) {
      error += error ? ",SMTP" : "";
    }
    if (record && !record.tracking_id.pop) {
      error += error ? ",POP" : "";
    }
    if (record && !record.tracking_id.imap) {
      error += error ? ",IMAP" : "";
    }
    if (record && !record.tracking_id.ftp) {
      error += error ? ",FTP" : "";
    }
    if (record && !record.tracking_id.smtp_submitsion_port) {
      error += error ? ",SMTP Submitsion Port" : "";
    }
    return "項目:" + error;
  }

  const columns = [
    {
      title: "送信時間",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: {
        compare: (a, b) => a.createdAt.localeCompare(b.createdAt),
        multiple: 2,
      },
      width: "35%",
      showSorterTooltip: false,
      render: (text) => <div>{formatDate(text)}</div>,
    },
    {
      title: languages.titleColumnAlertServer,
      dataIndex: "action",
      key: "action",
      width: "35%",
      sorter: {
        compare: (a, b) => a.server_id.name.localeCompare(b.server_id.name),
        multiple: 2,
      },
      showSorterTooltip: false,
      render: (text, record) =>
        record.server_id ? (
          <a onClick={() => onClickCell(record)}>
            <AreaChartOutlined className="icon-chart" />
            {record.server_id.name}
          </a>
        ) : null,
    },
    {
      title: languages.titleColumnStates,
      key: "action",
      width: "20%",
      showSorterTooltip: false,
      render: (text, record) => <>{errors(record)}</>,
    },
  ];
  return (
    <>
      <div className="section-title">{languages.titleNotification}</div>
      <Table
        dataSource={data}
        columns={columns}
        bordered={true}
        rowKey={"_id"}
        pagination={false}
      />
    </>
  );
};

export default ListNotifications;
